<template>
	<div class="tab-bar">
		<div class="ks-logo" @click="goIndex"></div>
		<div class="navs">
			<a v-for="item in $global.tabLists" :key="item.id" class="nav-item" :class="[isActiveId === item.id? 'active' : '']" @click="changeTab(item)">
				{{ item.text }}
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TabBar',
		data() {
			return {
				isActiveId : 1,
                id: 0, //结果类型id
                city: 0, //城市id
                type: 0, //结果类型
			}
		},
		methods: {
			changeTab(item) {
                //tab切换埋点
                if( item.title === 'auto_index' ) {
                    this.countAd(4507)
                }else if( item.title === 'auto_cms' ) {
                    this.countAd(4508)
                }else if( item.title === 'auto_bbs') {
                    this.countAd(4509)
                }else if( item.title === 'auto_video' ) {
                    this.countAd(4510)
                }else if( item.title === 'auto_baike' ) {
                    this.countAd(4511)
                }else if( item.title === 'picture' ) {
                    this.countAd(4512)
                }else if( item.title === 'dealers' ) {
                    this.countAd(4513)
                }else if( item.title === 'carQa' ) {
                    this.countAd(4514)
                }else if( item.title === 'auto_hj' ) {
                    this.countAd(4515)
                }

                if( item.title === this.$global.tab.title ) return
                if( item.title === 'picture' ) {
                    if(this.type === 3) {
                        window.open(`https://price.pcauto.com.cn/cars/sg${this.id}/#ad=5251`)
                    }else if(this.type === 2) {
                        window.open(`https://price.pcauto.com.cn/cars/b${this.id}/`)
                    }else if(this.type === 1) {
                        window.open(`https://price.pcauto.com.cn/cars/nb${this.id}/`)
                    }else {
                        window.open(`https://price.pcauto.com.cn/cars/common/auto_notfound?qtext=${this.$global.q}&t=2#ad=4554`)
                    }
                    return
                } 
                if( item.title === 'dealers' ) {
                    if( this.type === 3 ) {
                        window.open(`https://price.pcauto.com.cn/shangjia/c${this.city}/sg${this.id}/`)
                    }else if( this.type === 2 ) {
                        window.open(`https://price.pcauto.com.cn/shangjia/c${this.city}/b${this.id}/`)
                    }else if( this.type === 1 ) {
                        window.open(`https://price.pcauto.com.cn/shangjia/c${this.city}/nb${this.id}/`)
                    }else {
                        window.open(`https://price.pcauto.com.cn/shangjia/`)
                    }
                    return
                } 
                if( item.title === 'carQa' ) { return window.open(`https://www.pcauto.com.cn/wd/search/${this.$global.q}/`)} 
                // window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?q=${this.$global.q}&tab=${item.title}`)
				this.isActiveId = item.id
			},
            goIndex() {
                window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}`)
            },
            async reqType() {
                try {
                    const res = await this.fetType({q:this.$global.q}) 
                    this.id = res.id
                    this.city = res.rid
                    this.type = res.type
                } catch (error) {
                    console.error(error)
                }
            }
		},
        watch: {
            isActiveId(n,o) {   
                if(n != o) {
                    let tempItem = this.$global.tabLists.find(v => {return v.id === n})
                    this.$global.tab = tempItem
                    this.$EventBus.$emit('changeTab',tempItem)
                }
            }
        },
        mounted() {
            this.isActiveId = this.$global.tab.id
            this.reqType()
        }
	}
</script>

<style lang="scss" scoped>
.tab-bar {
	display: flex;
	.ks-logo {
		background-image:url($imageURL);
		background-position: 0 0;
		width: 89px;
		height: 29px;
        cursor: pointer;
	}
	.navs {
		display: flex;
		height: 29px;
		align-items: flex-end;
		margin-left: 25px;
		.nav-item {
            height: 19px;
			padding: 0 8px;
			font-size: 14px;
			cursor: pointer;
			&:hover {
                color: #FF6600;
				text-decoration-line: underline;
			}
			&.active {
                color: #FF6600;
                font-weight: 600;
			}
		}
	}
}
</style>